<template>
  <fieldset
    class="mb-3"
    :aria-describedby="ariaDescribedby"
    :aria-invalid="invalid ? 'true' : null"
    :aria-required="required ? 'true' : null"
  >
    <legend class="form-label">
      {{ label }}
      <span v-if="required" aria-hidden="true" class="text-danger">*</span>
    </legend>
    <div v-if="invalid" :id="errorId" class="invalid-feedback d-block">
      {{ errorMessage }}
    </div>
    <div v-for="option in options" :key="option.id" class="form-check">
      <input
        type="checkbox"
        :id="`${inputId}_${option.id}`"
        :name="inputName"
        :value="option.id"
        :checked="value.includes(option.id)"
        class="form-check-input"
        :required="required"
        @change="updateValue(option.id, $event.target.checked)"
      />
      <label :for="`${inputId}_${option.id}`" class="form-check-label">
        {{ option.name }}
      </label>
    </div>
  </fieldset>
</template>

<script>
  export default {
    computed: {
      state() {
        return this.invalid ? false : null;
      },
      invalid() {
        return !!this.errors.length;
      },
      inputName() {
        return `${this.modelName}[${this.name}][]`;
      },
      inputId() {
        return `${this.modelName}_${this.name}`;
      },
      descriptionId() {
        return `${this.inputId}_description`;
      },
      errorId() {
        return `${this.inputId}_error`;
      },
      ariaDescribedby() {
        const ids = [this.descriptionId];
        if (this.invalid) ids.push(this.errorId);
        return ids.join(' ');
      },
      errorMessage() {
        return this.errors.join(' and ');
      }
    },
    methods: {
      updateValue(optionId, isChecked) {
        const newValue = [...this.value];
        if (isChecked) {
          newValue.push(optionId);
        } else {
          const index = newValue.indexOf(optionId);
          if (index > -1) {
            newValue.splice(index, 1);
          }
        }
        this.$emit('update:value', newValue);
      }
    },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      options: {
        type: Array,
        required: true
      },
      required: {
        type: Boolean,
        required: false
      },
      name: {
        type: String,
        required: true
      },
      errors: {
        type: Array,
        default: () => []
      },
      label: {
        type: String,
        required: false
      },
      modelName: {
        type: String,
        required: true
      }
    }
  }
</script>
